export default __webpack_public_path__ + "static/media/bloggerly-white.8a8b2674.svg";